import * as React from 'react';
import { useState, useEffect } from 'react';
import useAuth from '../../../features/hooks/useAuth';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import styled from 'styled-components';
import moment from 'moment';
import { Span } from '../../../Styles/CommonStyles';
import { Chip } from '@mui/material';
import nameStringFn from '../../../data/nameStringFn';
import fetchPDF from '../../../data/fetchPDF';
import PdfModal from '../../../data/pdfmodal';



const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const SPAN = styled.div`
  cursor: pointer;
  color:blue;
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 8px;
`;

const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

export default function MyAssetDetailModal({assetdetailmodalopen,assetdetailModaldata, handleAssetDetailModalClose, users}) {

  const Auth = useAuth();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedfile, setSelectedFile] = useState(null);
  
  // Get auth token for API requests
  const token = useSelector(state => state.auth.token);



  const handleviewdoc = () =>{
    window.open(URL.createObjectURL(selectedfile), '_blank');
  }
  const  closeModal = () =>{
    setModalIsOpen(false);
  }
  const pdffetcher = async () =>{
    const file =await fetchPDF(assetdetailModaldata, token);
    setSelectedFile(file);
  }

  const fields = assetdetailModaldata? [
    { label: 'Category', value: assetdetailModaldata.category},
    { label: 'Asset', value: assetdetailModaldata.name },
    { label: 'OEM_Tag', value: assetdetailModaldata.oem_tag },
    { label: 'ORG_Tag', value: assetdetailModaldata.org_tag },
    { label: 'Brand', value: assetdetailModaldata.oem},
    { label: 'Specification', value: Object.entries(assetdetailModaldata.specification)},
    { label: 'User', value:assetdetailModaldata.alloc_user?.length?  nameStringFn(users[assetdetailModaldata.alloc_user]): "Not Applicable" },
    { label: 'Purchase Store', value:assetdetailModaldata.pur_store},
    { label: 'Current Store', value: assetdetailModaldata.cur_store },
    { label: 'In Transit', value:assetdetailModaldata.in_transit? "True":"False" },
    { label: 'Location', value:assetdetailModaldata.cur_loc },
    { label: 'Location Name', value:assetdetailModaldata.cur_loc_name },
    { label: 'Purchase Date', value:moment(assetdetailModaldata.purchase_date).format("DD/MM/YYYY")}, 
    { label: 'Warranty Exp Date', value:moment(assetdetailModaldata.warrantyexp_date).format("DD/MM/YYYY") },
    { label: 'Installation Date', value:moment(assetdetailModaldata.installation_date).format("DD/MM/YYYY") },
    Object.values(Auth.roles).flat(3).includes("ItemAdder_A") || Object.values(Auth.roles).flat(3).includes("L1Approver_A") || Object.values(Auth.roles).flat(3).includes("Admin") ? { label: 'Unit Price', value:`₹ ${assetdetailModaldata.unit_price}` }:null,
    { label: 'Last Tranasaction Date', value: assetdetailModaldata.last_trans_date?.length?  moment(assetdetailModaldata.last_trans_date).format("DD/MM/YYYY"):"Not Available"},
    Object.values(Auth.roles).flat(3).includes("ItemAdder_A") || Object.values(Auth.roles).flat(3).includes("L1Approver_A") || Object.values(Auth.roles).flat(3).includes("Admin") ? { label: 'Contract Document', value: <SPAN onClick={handleviewdoc}>Click here to view Document</SPAN> }:null,
  ]:[];

  useEffect(() =>{
    pdffetcher();
  },[])
  console.log(selectedfile)
  return (
    <React.Fragment>
      <Dialog  onClose={handleAssetDetailModalClose} aria-labelledby="customized-dialog-title" open={assetdetailmodalopen} maxWidth="md">
        <DialogTitle>
          <Span>User Details</Span>
        </DialogTitle>
          <DialogContent dividers>
            <ModalContent>
              <Table>
              <tbody>
              {fields.filter(x => x?.label?.length).map((item, index)=>
                 <tr id='email' key ={index}>
                    <TableCell>
                      <TableHeader>
                        {item?.label}
                      </TableHeader>
                    </TableCell>
                    
                    {item?.label === "Specification"?<TableCell>
                    { item?.value.map((elm, ind)=><Chip sx={{margin:"2px"}} key={ind} label = {`${elm[0]}: ${elm[1]}`} />)}
                    </TableCell>:

                     <TableCell>
                      { item?.value}
                    </TableCell>}
                  </tr>
                )
              }              
            </tbody>
                  </Table>
            </ModalContent>
          </DialogContent>
            <DialogActions >
              <Button onClick={handleAssetDetailModalClose}>Close</Button>
            </DialogActions>
      </Dialog>
      <PdfModal
        show = {modalIsOpen}
        onClose = {closeModal}
        pdfUrl = {selectedfile? URL.createObjectURL(selectedfile) : null}
      />
      </React.Fragment>
  );
}
